import React, { useState, useEffect, useReducer } from "react";
import { Anchor, Type } from "discover.medical.react-component-library";
import "./MySubscripttion.css";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "./../Spinner";
import SubscriptionInfo from "./SubscriptionInfo";
import AutoRenew from "./AutoRenew";
import { ViewPlans } from "./MySubscription.styled";

const toastMessages = {
  success: {
    message: "You've turned off auto-renew.",
  },
  error: {
    message:
      "We're sorry, something went wrong. Please try again later or contact support at (833) 520-9694.",
  },
};

export const actions = {
  SUBSCRIPTION_DETAILS_ARE_FETCHING: "SUBSCRIPTION_DETAILS_ARE_FETCHING",
  SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS:
    "SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS",
  SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR:
    "SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR",
  SWITCH_AUTO_RENEW_IN_PROGRESS: "SWITCH_AUTO_RENEW_IN_PROGRESS",
  SWITCH_AUTO_RENEW_HAS_FINISHED_SUCCESS:
    "SWITCH_AUTO_RENEW_HAS_FINISHED_SUCCESS",
  SWITCH_AUTO_RENEW_HAS_FINISHED_ERROR: "SWITCH_AUTO_RENEW_HAS_FINISHED_ERROR",
};

export const reducer = (state, action) => {
  const {
    SUBSCRIPTION_DETAILS_ARE_FETCHING,
    SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS,
    SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR,
    SWITCH_AUTO_RENEW_IN_PROGRESS,
    SWITCH_AUTO_RENEW_HAS_FINISHED_SUCCESS,
    SWITCH_AUTO_RENEW_HAS_FINISHED_ERROR,
  } = actions;

  switch (action.type) {
    case SUBSCRIPTION_DETAILS_ARE_FETCHING:
      return {
        ...state,
        subscriptionDetailsAreFetching: true,
      };
    case SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS:
      return {
        ...state,
        subscriptionDetailsAreFetching: false,
        subscriptionDetailsHasFetchedSuccess: true,
        subscriptionDetails: action.subscriptionDetails,
      };
    case SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR:
      return {
        ...state,
        SUBSCRIPTION_DETAILS_ARE_FETCHING: false,
        SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR: true,
        errorMessage: action.errorMessage,
      };
    case SWITCH_AUTO_RENEW_IN_PROGRESS:
      return {
        ...state,
        switchAutoRenewInProgress: true,
      };
    case SWITCH_AUTO_RENEW_HAS_FINISHED_SUCCESS:
      return {
        ...state,
        switchAutoRenewInProgress: false,
        switchAutoRenewHasFinishedSuccess: true,
        subscriptionDetails: action.subscriptionDetails,
      };
    case SWITCH_AUTO_RENEW_HAS_FINISHED_ERROR:
      return {
        ...state,
        switchAutoRenewInProgress: false,
        switchAutoRenewHasFinishedError: true,
      };
    default:
      throw new Error("Unknown action type");
  }
};

export const MySubscription = ({ api, userDetails, history }) => {
  const [state, dispatch] = useReducer(reducer, {
    subscriptionDetailsAreFetching: false,
    subscriptionDetailsHasFetchedSuccess: false,
    subscriptionDetailsHasFetchedError: false,
    subscriptionDetails: [],
    switchAutoRenewInProgress: false,
    switchAutoRenewHasFinishedSuccess: false,
    switchAutoRenewHasFinishedError: false,
    errorMessage: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState({ show: false, type: "success" });

  useEffect(() => {
    const { isPersonalized: personalized, isOrganizational: organizational } =
      userDetails?.userState;
    if (personalized && !organizational) {
      dispatch({ type: actions.SUBSCRIPTION_DETAILS_ARE_FETCHING });
      axios
        .get(`${api}/subscription/details`)
        .then((response) => {
          dispatch({
            type: actions.SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS,
            subscriptionDetails: response.data,
          });
        })
        .catch(() => {
          history.push("/store");
        });
    } else {
      history.push("/store");
    }
  }, [userDetails]);

  const handleSwitchAutoRenewSubmit = () => {
    dispatch({ type: actions.SWITCH_AUTO_RENEW_IN_PROGRESS });
    axios
      .put(`${api}/subscription/cancel`, {
        cancelAtPeriodEnd: true,
        subscriptionId: state.subscriptionDetails[0].id,
      })
      .then((response) => {
        setShowModal(false);
        setShowToast({ show: true, type: "success" });
        setTimeout(() => {
          setShowToast({ show: false, type: "success" });
        }, 3000);
        const subscriptionDetails = [...state.subscriptionDetails];
        subscriptionDetails.splice(0, 1, response.data);
        dispatch({
          type: actions.SWITCH_AUTO_RENEW_HAS_FINISHED_SUCCESS,
          subscriptionDetails,
        });
      })
      .catch(() => {
        setShowModal(false);
        setShowToast({ show: true, type: "error" });
        setTimeout(() => {
          setShowToast({ show: false, type: "error" });
        }, 3000);
        dispatch({
          type: actions.SWITCH_AUTO_RENEW_HAS_FINISHED_ERROR,
        });
      });
  };

  const hasSubscription =
    state.subscriptionDetails.length > 0 &&
    (state.subscriptionDetails[0].status === "active" ||
      state.subscriptionDetails[0].status === "trialing");

  const isTrialing = state.subscriptionDetails[0]?.status === "trialing";

  return (
    <section className="my-subscription">
      {state.subscriptionDetailsHasFetchedSuccess ? (
        <>
          <header className="my-subscription__header">
            <Type
              element="h1"
              styledAs="h2"
              fontFamily="secondary"
              marginBottom="sm"
            >
              My Subscription
            </Type>
          </header>
          {hasSubscription ? (
            <div className="my-subscription__content">
              <SubscriptionInfo
                subscriptionDetails={state.subscriptionDetails[0]}
                isSubscriptionDetailNotEmpty={
                  !!Object.keys(state.subscriptionDetails[0])
                }
              />
              <AutoRenew
                subscriptionDetails={state.subscriptionDetails[0]}
                setShowModal={setShowModal}
                isOpenedModal={showModal}
                handleSwitchAutoRenewSubmit={handleSwitchAutoRenewSubmit}
                showToast={showToast}
                message={toastMessages[showToast.type].message}
              />
            </div>
          ) : (
            <Type>
              There is no active individual paid subscription associated with
              your account. If you need help, please contact us at{" "}
              <Anchor href="mailto:medicalsupport@ebsco.com">
                medicalsupport@ebsco.com
              </Anchor>
              .
            </Type>
          )}
          {(isTrialing || !hasSubscription) && (
            <ViewPlans to="/store" as={Link}>
              View available plans
            </ViewPlans>
          )}
        </>
      ) : (
        <Spinner />
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  api: state.paths.api,
  userDetails: state.userDetails,
});

export default connect(mapStateToProps)(MySubscription);
